import { render, staticRenderFns } from "./DatabaseAuditLogsList.vue?vue&type=template&id=2acfb0e2&"
import script from "./DatabaseAuditLogsList.vue?vue&type=script&lang=js&"
export * from "./DatabaseAuditLogsList.vue?vue&type=script&lang=js&"
import style0 from "./DatabaseAuditLogsList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports